import React, {useEffect, useState} from 'react';
import {Container, Row} from 'reactstrap';
import TextInput from '../../../Shared/TextInput/TextInput';
import ProviderManager from '../../../../provider/providerManager';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import LightNotification from '../assets/lightNotification.svg';
import {PageView, ErrorView} from '../Shared/Constants';
import Image from 'app/Components/Shared/Image/image';
const ClientLocationLead = ({data, context, changeStep, setCurrentError}) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [buttonMsgSubmit, setButtonMsgSubmit] = useState();
  const [tittleError, setTittleError] = useState(<div />);
  const [messageError, setMessageError] = useState(<div />);
  const [error, setError] = useState({firstNameError: '', lastNameError: '', phoneNumberError: ''});

  useEffect(() => {
    setTittleError(
      <div className='client-location__error-tittle' dangerouslySetInnerHTML={{__html: data?.errorTittleValidationSession?.value}} />
    );
    setMessageError(
      <div className='client-location-lead__message' dangerouslySetInnerHTML={{__html: data?.errorMsgValidationSession?.value}} />
    );

    setButtonMsgSubmit(data?.buttonLead?.value);
  }, []);

  const onChange = (type, value) => {
    checkFieldValidation(type, value);
  };
  const checkFieldValidation = (type, value) => {
    let isValid = true;
    const validName = /^[א-תA-Za-z ."״()-/\'/׳]+$/;

    switch (type) {
      case 'firstName':
        setFirstName(value);
        if (value?.trim().length < 2 || !validName.test(value)) {
          error.firstNameError = 'אנא הכנס ערך תקין';
          setError({...error});
          isValid = false;
        } else {
          error.firstNameError = '';
          setError({...error});
        }
        break;
      case 'lastName':
        setLastName(value);
        if (value?.trim().length < 2 || !validName.test(value)) {
          error.lastNameError = 'אנא הכנס ערך תקין';
          setError({...error});
          isValid = false;
        } else {
          error.lastNameError = '';
          setError({...error});
        }
        break;
      case 'phoneNumber':
        setPhoneNumber(value);
        if (!/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(value)) {
          error.phoneNumberError = 'אנא הכנס ערך תקין';
          setError({...error});
          isValid = false;
        } else {
          error.phoneNumberError = '';
          setError({...error});
        }
    }
    return isValid;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      !checkFieldValidation('firstName', firstName) ||
      !checkFieldValidation('lastName', lastName) ||
      !checkFieldValidation('phoneNumber', phoneNumber)
    ) {
      return;
    }
    changeStep(PageView.LeadLoader);
    const fullName = firstName + ' ' + lastName;
    const phone = phoneNumber;
    const url = encodeURI(window.location.href);
    const bannerId = '';
    const searchTerm = '';
    const adSource = '';
    const isAgreementsCheckBoxActive = false;
    const recaptchaToken = '';
    const campaignCode = data?.clCampaignCode?.value;
    const campaignName = data?.clCampaignName?.value;
    const productId = data?.clProductId?.value;
    const description = '';

    try {
      const result = await ProviderManager.getProviderData('createLead', [
        recaptchaToken,
        fullName,
        phone,
        campaignCode,
        campaignName,
        productId,
        adSource,
        url,
        bannerId,
        searchTerm,
        isAgreementsCheckBoxActive,
        description
      ]);
      if (result.Body.isSuccess) {
        changeStep(PageView.LeadCompleted);
      } else {
        setCurrentError(ErrorView.SaveDB);
        changeStep(PageView.ErrorPopUp);
      }
    } catch (error) {
      setCurrentError(ErrorView.SaveDB);
      changeStep(PageView.ErrorPopUp);
    }
  };

  return (
    <>
      <Container>
        <div className='client-location__errorPopUp'>
          {tittleError}
          <section className='client-location__error-img'>
            <Image src={LightNotification} alt='פעמון התראה' />
          </section>
          <section>{messageError}</section>
          <form noValidate id='clientLocation' onSubmit={handleSubmit}>
            <TextInput
              onChange={(e) => onChange('firstName', e.target.value)}
              value={firstName}
              className='text-input'
              placeholder='שם פרטי'
              type='text'
              autoComplete='off'
              required='required'
              error={error.firstNameError}
            />

            <TextInput
              onChange={(e) => onChange('lastName', e.target.value)}
              value={lastName}
              className='text-input'
              placeholder='שם משפחה'
              type='text'
              autoComplete='off'
              required='required'
              error={error.lastNameError}
            />

            <TextInput
              className='text-input'
              onChange={(e) => onChange('phoneNumber', e.target.value)}
              value={phoneNumber}
              placeholder='טלפון נייד'
              type='text'
              autoComplete='off'
              required='required'
              maxLength='10'
              error={error.phoneNumberError}
            />
          </form>
          <Row className='justify-content-center'>
            <span className='client-location-lead__info'>או לפנות למוקד *2426</span>
          </Row>
        </div>
      </Container>
      <div className='init-step__button'>
        <BtnSubmit text={buttonMsgSubmit} formid='clientLocation' onclick={handleSubmit} />
      </div>
    </>
  );
};

export default ClientLocationLead;
